import React, { Component } from "react";
import { callPlayer, getSDK, queryString } from "../utils.js";
const SDK_URL = "https://widget.mixcloud.com/media/js/widgetApi.js";
const SDK_GLOBAL = "Mixcloud";
const MATCH_URL = /mixcloud\.com\/([^/]+\/[^/]+)/;
class Mixcloud extends Component {
  constructor() {
    super(...arguments);
    this.callPlayer = callPlayer;
    this.duration = null;
    this.currentTime = null;
    this.secondsLoaded = null;
    this.mute = () => {
    };
    this.unmute = () => {
    };
    this.ref = (iframe) => {
      this.iframe = iframe;
    };
  }
  load(_url) {
    getSDK(SDK_URL, SDK_GLOBAL).then((Mixcloud2) => {
      this.player = Mixcloud2.PlayerWidget(this.iframe);
      this.player.ready.then(() => {
        this.player.events.play.on(this.props.onPlay);
        this.player.events.pause.on(this.props.onPause);
        this.player.events.ended.on(this.props.onEnded);
        this.player.events.error.on(this.props.error);
        this.player.events.progress.on((seconds, duration) => {
          this.currentTime = seconds;
          this.duration = duration;
        });
        this.props.onReady();
      });
    }, this.props.onError);
  }
  play() {
    this.callPlayer("play");
  }
  pause() {
    this.callPlayer("pause");
  }
  stop() {
  }
  seekTo(seconds) {
    this.callPlayer("seek", seconds);
  }
  setVolume(_fraction) {
  }
  getDuration() {
    return this.duration;
  }
  getCurrentTime() {
    return this.currentTime;
  }
  getSecondsLoaded() {
    return null;
  }
  render() {
    const { url, config } = this.props;
    const id = url.match(MATCH_URL)[1];
    const style = {
      width: "100%",
      height: "100%"
    };
    const query = queryString({
      ...config.mixcloud.options,
      feed: `/${id}/`
    });
    return (
      // oxlint-disable-next-line jsx-a11y/iframe-has-title
      /* @__PURE__ */ React.createElement(
        "iframe",
        {
          key: id,
          ref: this.ref,
          style,
          src: `https://www.mixcloud.com/widget/iframe/?${query}`,
          frameBorder: "0"
        }
      )
    );
  }
}
Mixcloud.displayName = "Mixcloud";
Mixcloud.canPlay = (url) => MATCH_URL.test(url);
Mixcloud.loopOnEnded = true;
export {
  Mixcloud
};
//# sourceMappingURL=mixcloud.js.map
